<template>
    <q-page class="q-pa-md">
        <q-dialog class="rounded-borders" v-model="dialogVehiculo" persistent>
            <q-card style="width: 1200px; max-width: 80vw;" class="shadow-0">
                <q-card-section class="row items-center q-pb-none">
                    <div class="text-h6">Vehiculo</div>
                    <q-space />
                    <q-btn icon="close" flat round dense v-close-popup />
                </q-card-section>
                <q-card-section>
                    <q-stepper v-model="step" ref="stepper" header-nav bordered color="primary" animated
                        class="shadow-0">
                        <!-- INFORMACION DEL CLIENTE Y DE SUS DOCUMENTOS -->
                        <q-step :name="1" title="Vehiculo y Seguro" icon="settings" :done="done1">
                            <q-card class="shadow-0" v-if="auto">
                                <q-card-section>
                                    <div class="row q-col-gutter-sm">
                                        <div class="col-12">
                                            <div class="text-subtitle2">Modelo del Vehiculo</div>
                                            <q-separator />
                                        </div>

                                        <div class="col-12 col-md-12">
                                            <q-input v-model="auto.agencia" outlined label="Agencia" dense required
                                                readonly />
                                        </div>
                                        <div class="col-12 col-md-4">
                                            <q-input v-model="auto.marca" outlined label="Nombre de marca" dense
                                                required readonly />
                                        </div>
                                        <div class="col-12 col-md-4">
                                            <q-input v-model="auto.modelo" outlined label="Modelo" dense required
                                                readonly />
                                        </div>

                                        <div class="col-12 col-md-4">
                                            <q-input v-model="auto.version" outlined label="Version" dense required
                                                readonly />
                                        </div>
                                        <div class="col-12 col-md-4">
                                            <q-input v-model="auto.tipoVehiculo" outlined label="Tipo de Vehiculo" dense
                                                required readonly />
                                        </div>
                                        <div class="col-12 col-md-4">
                                            <q-input v-model="auto.anio" outlined label="Año" dense required readonly />
                                        </div>
                                        <div class="col-12 col-md-4">
                                            <q-input v-model="auto.color" outlined label="Color" dense required
                                                readonly />
                                        </div>
                                        <div class="col-12 q-mt-md">
                                            <div class="text-subtitle2">Datos del Vehiculo </div>
                                            <q-separator />
                                        </div>
                                        <div class="col-12 col-md-4">
                                            <q-input readonly v-model="auto.numeroSerie" outlined
                                                label="Número de Serie" dense required />
                                        </div>
                                        <div class="col-12 col-md-4">
                                            <q-input readonly v-model="auto.numeroMotor" outlined
                                                label="Número de Motor" dense required />
                                        </div>

                                        <div class="col-12 col-md-4">
                                            <q-input readonly v-model="auto.placa" outlined label="Placa" dense
                                                required />
                                        </div>
                                        <div class="col-12 col-md-6">
                                            <q-input readonly v-model="auto.estadoPlaca" outlined
                                                label="Estado (Origen)" dense required />
                                        </div>
                                        <div class="col-12 col-md-6">
                                            <q-input readonly class="q-ma-none q-pa-none" dense outlined
                                                v-model="auto.fechaadquisicion" label="Fecha de Adquisición" mask="date"
                                                bottom-slots placeholder="yyyy/MM/dd">
                                                <template v-slot:after>
                                                    <q-icon name="event" class="q-ma-none q-pa-none cursor-pointer">

                                                    </q-icon>
                                                </template>
                                            </q-input>
                                        </div>
                                        <div class="col-12 col-md-12">
                                            <q-input readonly v-model="auto.beneficionproveedor" outlined label="Notas"
                                                dense required />
                                        </div>

                                        <div class="col-12 q-mt-md">
                                            <div class="text-subtitle2">Datos del seguro</div>
                                            <q-separator />
                                        </div>
                                        <div class="col-12 col-md-4">
                                            <q-input readonly class="q-ma-none q-pa-none" dense outlined
                                                v-model="selectSeguro.fechaemision" label="Fecha de Emisión" mask="date"
                                                bottom-slots placeholder="yyyy/MM/dd">
                                                <template v-slot:after>
                                                    <q-icon name="event" class="q-ma-none q-pa-none cursor-pointer">

                                                    </q-icon>
                                                </template>
                                            </q-input>
                                        </div>
                                        <div class="col-12 col-md-4">
                                            <q-input readonly class="q-ma-none q-pa-none" dense outlined
                                                v-model="selectSeguro.finicio" label="Fecha de Inicio" mask="date"
                                                bottom-slots placeholder="yyyy/MM/dd">
                                                <template v-slot:after>
                                                    <q-icon name="event" class="q-ma-none q-pa-none cursor-pointer">

                                                    </q-icon>
                                                </template>
                                            </q-input>
                                        </div>
                                        <div class="col-12 col-md-4">
                                            <q-input readonly v-model="selectSeguro.poliza" outlined
                                                label="Número de Poliza" dense required />
                                        </div>
                                        <div class="col-12 col-md-12">
                                            <q-input readonly v-model="selectSeguro.compania" outlined label="Seguro"
                                                dense required />
                                        </div>
                                        <div class="col-12 col-md-6">
                                            <q-input readonly v-model="selectSeguro.tipo" outlined
                                                label="Tipo de Seguro" dense required />
                                        </div>
                                        <div class="col-12 col-md-6">
                                            <q-field readonly stack-label outlined label="Costo Total" dense>
                                                <template v-slot:control>
                                                    <div class="self-center text-right full-width no-outline"
                                                        tabindex="0">{{
                                                            formatoMonedaMexicana(selectSeguro.costototal) }}</div>
                                                </template>
                                            </q-field>
                                        </div>
                                        <div class="col-12 col-md-4">
                                            <q-input readonly v-model="selectSeguro.agentedemisiones" outlined
                                                label="Agente de Emisiones" dense required />
                                        </div>
                                        <div class="col-12 col-md-4">
                                            <q-input readonly v-model="selectSeguro.oficinaregional" outlined
                                                label="Oficina Regional" dense required />
                                        </div>
                                        <div class="col-12 col-md-4">
                                            <q-input readonly v-model="selectSeguro.numerotelsiniestro"
                                                mask="(###) ### - ####" outlined label="Número Teléfonico de Siniestros"
                                                dense required />
                                        </div>
                                    </div>
                                </q-card-section>

                            </q-card>
                        </q-step>
                        <q-step :name="2" title="Poliza de Seguro Seguro" icon="settings" :done="done2">
                            <q-card class="shadow-0" v-if="auto">
                                <q-card-section>
                                    <VisualizadorPDF></VisualizadorPDF>
                                </q-card-section>
                            </q-card>
                        </q-step>

                    </q-stepper>
                </q-card-section>
            </q-card>
        </q-dialog>

        <q-dialog class="rounded-borders" v-model="dialogDetalles" persistent>
            <q-card style="width: 1100px; max-width: 80vw;">
                <q-card-section class="row items-center q-pb-none">
                    <div class="text-h6">Seguro</div>
                    <q-space />
                    <q-btn icon="close" flat round dense v-close-popup />
                </q-card-section>
                <q-card-section class="row items-center q-pb-none q-col-gutter-md ">

                    <div class="col-12">
                        <q-select outlined v-model="selectCliente" :options="clientes" label="Cliente"
                            option-label="rfc" dense required emit-value map-options
                            @input="GetVehiculosPorClienteAsync">
                            <template v-slot:option="scope">
                                <q-item v-bind="scope.itemProps" v-on="scope.itemEvents">
                                    <q-item-section avatar>
                                        <q-icon name="mdi-account" color="priamry" />
                                    </q-item-section>
                                    <q-item-section>
                                        <q-item-label v-html="scope.opt.rfc + ' ' + scope.opt.razon_social" />
                                    </q-item-section>
                                </q-item>
                            </template>
                        </q-select>
                    </div>
                    <div class="col-12">
                        <q-select outlined v-model="selectAuto" :options="autosCliente" label="Vehículo"
                            option-label="texto" option-value="id" dense emit-value map-options>
                            <template v-slot:option="scope">
                                <q-item v-bind="scope.itemProps" v-on="scope.itemEvents">
                                    <q-item-section avatar>
                                        <q-icon name="mdi-car" color="priamry" />
                                    </q-item-section>
                                    <q-item-section>
                                        <q-item-label>{{ scope.opt.marca }} {{ scope.opt.modelo }} ({{ scope.opt.anio
                                        }})</q-item-label>
                                        <q-item-label caption>Placa: {{ scope.opt.placa }}</q-item-label>
                                    </q-item-section>
                                </q-item>
                            </template>
                        </q-select>
                    </div>
                    <div class="col-12 col-md-12">
                        <q-select dense outlined v-model="selectAgencia" :options="listaAgencias" label="Proveedor"
                            color="primary" option-label="razon_social" clearable
                            options-selected-class="text-deep-blue">
                            <template v-slot:option="scope">
                                <q-item v-bind="scope.itemProps" v-on="scope.itemEvents">
                                    <q-item-section avatar>
                                        <q-icon name="mdi-car" color="priamry" />
                                    </q-item-section>
                                    <q-item-section>
                                        <q-item-label v-html="scope.opt.rfc + ' - ' + scope.opt.razon_social" />
                                        <q-item-label caption>{{ scope.opt.representante
                                            }}</q-item-label>
                                    </q-item-section>
                                </q-item>
                            </template>
                        </q-select>
                    </div>
                    <div class="col-12">
                        <div class="text-subtitle2">Datos de la Poliza de Seguro </div>
                        <q-separator />
                    </div>

                    <div class="col-12 col-md-3">
                        <q-input class="q-pb-none" dense outlined v-model="fechaemision" label="Fecha de Emisión"
                            mask="date" bottom-slots placeholder="yyyy/MM/dd">
                            <template v-slot:after>
                                <q-icon name="event" class="q-ma-none q-pa-none cursor-pointer">
                                    <q-popup-proxy class="q-ma-none q-pa-none" ref="qDateProxy" transition-show="scale"
                                        transition-hide="scale">
                                        <q-date class="q-ma-none q-pa-none" v-model="fechaemision">
                                            <div class="row items-center justify-end q-ma-none q-pa-none">
                                                <q-btn v-close-popup label="Ok" color="primary"
                                                    class="q-ma-none q-pa-none" flat />
                                            </div>
                                        </q-date>
                                    </q-popup-proxy>
                                </q-icon>
                            </template>
                        </q-input>
                    </div>

                    <div class="col-12 col-md-3">
                        <q-input class="q-pb-none" dense outlined v-model="finicio" label="Vigencia Inicial" mask="date"
                            bottom-slots placeholder="yyyy/MM/dd">
                            <template v-slot:after>
                                <q-icon name="event" class="q-ma-none q-pa-none cursor-pointer">
                                    <q-popup-proxy class="q-ma-none q-pa-none" ref="qDateProxy" transition-show="scale"
                                        transition-hide="scale">
                                        <q-date class="q-ma-none q-pa-none" v-model="finicio">
                                            <div class="row items-center justify-end q-ma-none q-pa-none">
                                                <q-btn v-close-popup label="Ok" color="primary"
                                                    class="q-ma-none q-pa-none" flat />
                                            </div>
                                        </q-date>
                                    </q-popup-proxy>
                                </q-icon>
                            </template>
                        </q-input>
                    </div>

                    <div class="col-12 col-md-3">
                        <q-input class="q-pb-none" dense outlined v-model="fvencimiento" label="Vigencia Final"
                            mask="date" bottom-slots placeholder="yyyy/MM/dd">
                            <template v-slot:after>
                                <q-icon name="event" class="q-ma-none q-pa-none cursor-pointer">
                                    <q-popup-proxy class="q-ma-none q-pa-none" ref="qDateProxy" transition-show="scale"
                                        transition-hide="scale">
                                        <q-date class="q-ma-none q-pa-none" v-model="fvencimiento">
                                            <div class="row items-center justify-end q-ma-none q-pa-none">
                                                <q-btn v-close-popup label="Ok" color="primary"
                                                    class="q-ma-none q-pa-none" flat />
                                            </div>
                                        </q-date>
                                    </q-popup-proxy>
                                </q-icon>
                            </template>
                        </q-input>
                    </div>

                    <div class="col-12 col-md-3">
                        <q-input class="q-pb-none" dense outlined v-model="flimitepago" label="Fecha limite de Pago"
                            mask="date" bottom-slots placeholder="yyyy/MM/dd">
                            <template v-slot:after>
                                <q-icon name="event" class="q-ma-none q-pa-none cursor-pointer">
                                    <q-popup-proxy class="q-ma-none q-pa-none" ref="qDateProxy" transition-show="scale"
                                        transition-hide="scale">
                                        <q-date class="q-ma-none q-pa-none" v-model="flimitepago">
                                            <div class="row items-center justify-end q-ma-none q-pa-none">
                                                <q-btn v-close-popup label="Ok" color="primary"
                                                    class="q-ma-none q-pa-none" flat />
                                            </div>
                                        </q-date>
                                    </q-popup-proxy>
                                </q-icon>
                            </template>
                        </q-input>
                    </div>
                    <div class="col-12 col-md-8">
                        <q-input dense v-model="tipo" outlined label="Tipo de Seguro" required />
                    </div>
                    <div class="col-12 col-md-4">
                        <q-input dense v-model="poliza" outlined label="Póliza" required />
                    </div>
                    <div class="col-12 col-md-4">
                        <q-input dense v-model="endoso" outlined label="Posible Endoso" required />
                    </div>
                    <div class="col-12 col-md-4">
                        <q-select outlined v-model="formapago"
                            :options="['Mensual', ' Trimestral', 'Semestral', 'Anual']" label="Forma de Pago" dense
                            required>
                        </q-select>
                    </div>
                    <div class="col-12 col-md-4">
                        <q-input prefix="$" dense v-model="costototal" outlined label="Costo Total" required mask="#.##"
                            fill-mask="0" reverse-fill-mask input-class="text-right" />
                    </div>

                    <div class="col-12 col-md-4">
                        <q-input dense v-model="agentedemisiones" outlined label="Agente de Emisiones" required />
                    </div>
                    <div class="col-12 col-md-4">
                        <q-input dense v-model="numerotelsiniestro" outlined label="Número Teléfonico para Siniestros"
                            required mask="(###) ### - ####" />
                    </div>
                    <div class="col-12 col-md-4">
                        <q-input dense v-model="oficinaregional" outlined label="Oficina Regional" required />
                    </div>
                    <div class="col-12 col-md-12">
                        <q-file v-model="archivoSeleccionado" dense outlined label="Subir Documento PDF de la Póliza"
                            class="full-width" accept=".pdf,application/pdf">
                        </q-file>
                    </div>

                    <div class="col-12 col-md-12">
                        <q-input dense v-model="notas" outlined label="Notas" required />
                    </div>

                    <div class="col-12">
                        <div class="text-subtitle2">Datos de la cuenta por Cobrar </div>
                        <q-separator />
                    </div>
                    <div class="col-12 col-md-3">
                        <q-select outlined v-model="formacobro"
                            :options="['Mensual', ' Trimestral', 'Semestral', 'Anual']" label="Forma de Cobro" dense
                            required>
                        </q-select>
                    </div>
                    <div class="col-12 col-md-3">
                        <q-input prefix="$" dense v-model="pagoperiodo" outlined label="Total a pagar por periodo"
                            required mask="#.##" fill-mask="0" reverse-fill-mask input-class="text-right" />
                    </div>
                    <div class="col-12 col-md-3">
                        <q-input class="q-pb-none" dense outlined v-model="flimitecobro"
                            label="Fecha limite de Cobro al cliente" mask="date" bottom-slots placeholder="yyyy/MM/dd">
                            <template v-slot:after>
                                <q-icon name="event" class="q-ma-none q-pa-none cursor-pointer">
                                    <q-popup-proxy class="q-ma-none q-pa-none" ref="qDateProxy" transition-show="scale"
                                        transition-hide="scale">
                                        <q-date class="q-ma-none q-pa-none" v-model="flimitecobro">
                                            <div class="row items-center justify-end q-ma-none q-pa-none">
                                                <q-btn v-close-popup label="Ok" color="primary"
                                                    class="q-ma-none q-pa-none" flat />
                                            </div>
                                        </q-date>
                                    </q-popup-proxy>
                                </q-icon>
                            </template>
                        </q-input>
                    </div>
                    <div class="col-12 col-md-3">
                        <q-input prefix="$" dense v-model="pagoinicial" outlined label="Pago Inicial" required
                            mask="#.##" fill-mask="0" reverse-fill-mask input-class="text-right" />
                    </div>

                </q-card-section>
                <div class="q-ma-md doc-note">
                    <p class="doc-note__title">Aviso</p>
                    <p class=""> Al crear la cuenta por pagar, asi mismo se le creara una cuanta por cobrar al
                        cliente.</p>
                </div>
                <q-card-actions class="row justify-between">
                    <q-btn flat color="red" label="Cerrar" v-close-popup />
                    <q-btn flat color="primary" label="Crear Seguro" @click="PostSeguro()" />
                </q-card-actions>
            </q-card>
        </q-dialog>


        <div class="row q-pt-md q-col-gutter-md">
            <!-- Columna derecha: tabla ocupa más espacio si no hay formulario -->
            <div class="col-md-12 col-12'">
                <q-table dense title="Seguros" class="shadow-1" :data="items" :loading="loading" :columns="columns"
                    color="primary" row-key="_id" :pagination="initialPagination">
                    <template v-slot:top-right>

                        <q-btn outline ref="" color="primary" icon="mdi-refresh" label="Actualizar" no-caps
                            class="q-mr-sm q-my-md" @click="GetListaSeguros" />
                        <q-btn outline color="primary" icon="mdi-plus" label="Nuevo" class="q-my-md"
                            @click="nuevoItem()" />
                    </template>
                    <template v-slot:body="props">
                        <q-tr :props="props" class="hover-fila">
                            <q-td key="compania" :props="props" @click="verItem(props.row)">{{ props.row.compania
                            }}</q-td>
                            <q-td key="poliza" :props="props" @click="verItem(props.row)">{{ props.row.poliza }}</q-td>
                            <q-td key="tipo" :props="props" @click="verItem(props.row)">{{
                                props.row.tipo }}</q-td>
                            <q-td key="fechaemision" :props="props" @click="verItem(props.row)">{{
                                formatearFecha(props.row.fechaemision) }}</q-td>
                            <q-td key="finicio" :props="props" @click="verItem(props.row)">{{
                                formatearFecha(props.row.finicio) }}</q-td>
                            <q-td key="fvencimiento" :props="props" @click="verItem(props.row)">{{
                                formatearFecha(props.row.fvencimiento)
                            }}</q-td>
                            <q-td key="formapago" :props="props" @click="verItem(props.row)">{{
                                props.row.formapago
                            }}</q-td>
                            <q-td key="costototal" :props="props" @click="verItem(props.row)">{{
                                formatoMonedaMexicana(props.row.costototal)
                            }}</q-td>
                            <q-td key="estado" :props="props" @click="verItem(props.row)">
                                <q-badge v-if="props.row.estado == 'activo'" color="green" label="Activo" />
                                <q-badge v-if="props.row.estado == 'inactivo'" color="organge" label="Inactivo" />
                            </q-td>
                        </q-tr>
                    </template>
                </q-table>
            </div>
        </div>
    </q-page>
</template>

<script>
import axios from "axios";
import { QSpinnerClock } from 'quasar'
import VisualizadorPDF from "../../PDF/VistasPreviasPDF.vue";

export default {
    components: {
        VisualizadorPDF
    },
    data() {
        return {
            step: 1,
            done1: false,
            done2: false,
            loading: false,
            items: [],
            columns: [
                { name: 'compania', label: 'Aseguradora', field: 'compania', align: 'center', sortable: true },
                { name: 'poliza', label: 'Poliza', field: 'poliza', align: 'center', sortable: true },
                { name: 'tipo', label: 'Tipo', field: 'tipo', align: 'center', sortable: true },
                { name: 'fechaemision', label: 'Fecha de Emisión', field: 'fechaemision', align: 'center', sortable: true },
                { name: 'finicio', label: 'Fecha de Inicio', field: 'finicio', align: 'center', sortable: true },
                { name: 'fvencimiento', label: 'Fecha de Vencimiento', field: 'fvencimiento', align: 'center', sortable: true },
                { name: 'formapago', label: 'Forma de Pago', field: 'formapago', align: 'center', sortable: true },
                { name: 'costototal', label: 'Costo Total', field: 'costototal', align: 'center', sortable: true },
                { name: 'estado', label: 'Estado', field: 'estado', align: 'center', sortable: true }
            ],

            initialPagination: {
                sortBy: 'rfc',
                descending: false,
                page: 1,
                rowsPerPage: 10
            },
            dialogDetalles: false,
            clientes: [],
            selectCliente: null,
            selectAuto: null,
            autosCliente: [],
            listaAgencias: [],
            selectAgencia: null,

            fechaemision: '',
            finicio: '',
            fvencimiento: '',
            flimitepago: '',
            flimitecobro: '',
            notas: '',
            poliza: '',
            costototal: 0,
            pagoinicial: 0,
            pagoperiodo: 0,
            formapago: '',
            formacobro: '',
            endoso: '',
            tipo: '',
            agentedemisiones: '',
            numerotelsiniestro: '',
            oficinaregional: '',
            pdfPoliza: {},
            archivoSeleccionado: null,

            dialogVehiculo: false,
            auto: null,
            selectSeguro: null
        };
    },
    computed: {

    },
    created() {
        this.GetClientes()
        this.GetProveedores()
        this.GetListaSeguros()
    },
    methods: {
        async verItem(item) {
            this.selectSeguro = item
            console.log(item)
            this.$q.loading.show({ spinner: QSpinnerClock, spinnerColor: 'white', spinnerSize: 90, message: 'Consultando detalles. Espere...', messageColor: 'white' })
            try {
                let respuesa = await axios.get('Autos/GetAutosPorIdAutoDetalles/' + this.selectSeguro._id + '/' + item.id_auto)
                console.log(respuesa)
                this.auto = respuesa.data.seguros
                this.$store.state.auth.storeBase64Cotizacion = respuesa.data.polizaPdf.b64com + ',' + respuesa.data.polizaPdf.poliza

            } catch (error) {
                console.log(error)
            }
            this.$q.loading.hide()
            this.dialogVehiculo = true
        },

        nuevoItem() {
            this.selectCliente = null;
            this.selectAuto = null;
            this.autosCliente = [];
            this.selectAgencia = null;
            this.dialogDetalles = true
            this.fechaemision = ''
            this.finicio = ''
            this.fvencimiento = ''
            this.flimitepago = ''
            this.flimitecobro = ''
            this.notas = ''
            this.poliza = ''
            this.costototal = 0
            this.pagoinicial = 0
            this.pagoperiodo = 0
            this.formapago = ''
            this.formacobro = ''
            this.endoso = ''
            this.tipo = ''
            this.agentedemisiones = ''
            this.numerotelsiniestro = ''
            this.oficinaregional = ''
        },
        async GetClientes() {
            try {
                let respuesa = await axios.get('Configuracion/GetUsuariosDatosFiscales/')
                // let respuesa = await axios.get('Login/GetClientes/')
                console.log(respuesa)
                this.clientes = respuesa.data
            } catch (error) {
                console.log(error)
            }
        },

        async GetVehiculosPorClienteAsync() {
            if (!this.selectCliente) return;

            try {
                const res = await axios.get(`Autos/GetVehiculosPorClienteAsync/${this.selectCliente._id_cliente}`);
                // Puedes agregar campo "texto" al vuelo si quieres usarlo en option-label (opcional)
                console.log(res)
                this.autosCliente = res.data.map(auto => ({
                    ...auto,
                    texto: `${auto.marca} ${auto.modelo} (${auto.anio}) - ${auto.placa}`
                }));
            } catch (err) {
                console.error('Error al obtener autos:', err);
                this.autosCliente = [];
            }
        },
        async GetProveedores() {
            try {
                let respuesa = await axios.get('Catalogos/GetProveedoresTipo/Seguro')
                console.log(respuesa.data)
                this.listaAgencias = respuesa.data
            } catch (error) {
                console.log(error)
            }
        },
        async GetListaSeguros() {
            this.loading = true
            try {
                let respuesa = await axios.get('Autos/GetListaSeguros/')
                console.log(respuesa)
                this.items = respuesa.data
                this.loading = false
            } catch (error) {
                this.loading = false
                console.log(error)
            }
        },
        async PostSeguro() {
            if (this.selectAuto == null) {
                this.$q.notify({ type: 'warning', position: 'top-right', message: `Indique el auto al que se le asignara el seguro.` });
                return
            }
            if (this.selectCliente == null) {
                this.$q.notify({ type: 'warning', position: 'top-right', message: `Indique el cliente al que se le haran los cargos.` });
                return
            }
            if (this.selectAgencia == null) {
                this.$q.notify({ type: 'warning', position: 'top-right', message: `Indique el Proveedor de su Seguro.` });
                return
            }

            const archivo = this.archivoSeleccionado;
            if (!archivo) {
                this.$q.notify({
                    color: 'negative',
                    message: 'Debe cargar el Documero PDF de la poliza.',
                    position: 'top-right'
                });
                return;
            }

            const base64 = await this.convertirABase64(archivo);
            let nombre_archivo = archivo.name;
            let archivo64base = base64;

            let objeto = {
                id_auto: this.selectAuto,
                id_cliente: this.selectCliente._id_cliente,
                nombrecliente: this.selectCliente.rfc + ' ' + this.selectCliente.razon_social,
                fechaemision: this.fechaemision,
                finicio: this.finicio,
                fvencimiento: this.fvencimiento,
                flimitepago: this.flimitepago,
                flimitecobro: this.flimitecobro,
                notas: this.notas,
                poliza: this.poliza,
                id_proveedor: this.selectAgencia._id,
                compania: this.selectAgencia.razon_social,
                costototal: this.costototal,
                pagoinicial: this.pagoinicial,
                pagoperiodo: this.pagoperiodo,
                formapago: this.formapago,
                formacobro: this.formacobro,
                tipo: this.tipo,
                endoso: this.endoso,
                agentedemisiones: this.agentedemisiones,
                numerotelsiniestro: this.numerotelsiniestro,
                oficinaregional: this.oficinaregional,
                polizaPdf: {
                    poliza: archivo64base,
                    ruta: '',
                    nombre: nombre_archivo,
                }
            }

            try {

                console.log(objeto)
                this.$q.loading.show({ spinner: QSpinnerClock, spinnerColor: 'white', spinnerSize: 90, message: 'Asignando seguro. Espere...', messageColor: 'white' })

                const resp = await axios.post(`Autos/AltaSeguro/`, objeto);
                console.log(resp)

                if (resp.data.edopet == "0") {
                    this.$q.notify({ type: 'positive', position: 'top-right', message: `Se asigno correctamento el seguro al vehiculo.` });
                    this.dialogDetalles = false
                } else {
                    this.$q.notify({ type: 'negative', position: 'top-right', message: `Error al crear el seguro. Intentelo de nuevo...` });
                }
                this.$q.loading.hide()

            } catch (error) {
                this.$q.loading.hide()
                this.$q.notify({ type: 'negative', position: 'top-right', message: `Error al crear el seguro. Intentelo de nuevo...` });
                console.log(error)
            }
        },
        formatoMonedaMexicana(valor) {
            return valor.toLocaleString('es-MX', {
                style: 'currency',
                currency: 'MXN',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            });
        },
        formatearFecha(isoString) {
            const fecha = new Date(isoString);

            const dia = String(fecha.getUTCDate()).padStart(2, '0');
            const mes = String(fecha.getUTCMonth() + 1).padStart(2, '0');
            const anio = fecha.getUTCFullYear();

            const hora = String(fecha.getUTCHours()).padStart(2, '0');
            const minutos = String(fecha.getUTCMinutes()).padStart(2, '0');
            const segundos = String(fecha.getUTCSeconds()).padStart(2, '0');

            return `${dia}/${mes}/${anio} ${hora}:${minutos}:${segundos}`;
        },

        convertirABase64(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = (e) => resolve(e.target.result);
                reader.onerror = reject;
                reader.readAsDataURL(file);
            });
        },
    }
};
</script>
<style>
.hover-fila:hover td {
    cursor: pointer;
    background: #dcf6ff;
}

.q-table thead,
[dir] .q-table tr,
[dir] .q-table th {
    border-color: #0094ca !important;
}

.doc-note {
    background-color: #f0f4f8;
    /* Fondo claro */
    border-left: 4px solid #007BFF;
    /* Línea de color azul en el borde izquierdo */
    padding: 16px;
    margin: 16px 0;
    border-radius: 8px;
    color: #333;
    /* Color de texto */
    font-family: Arial, sans-serif;
}

.doc-note__title {
    margin: 0 0 8px 0;
    font-weight: bold;
    color: #007BFF;
    /* Mismo tono del borde para coherencia */
    font-size: 16px;
}

.doc-note p {
    margin: 0;
    font-size: 14px;
    line-height: 1.5;
}
</style>